import React, { useState } from "react";
import ButtonPrimary from "./ButtonPrimary";
import { MdArrowDropDown } from "react-icons/md/index";
import { BiFilterAlt } from "react-icons/bi";

export default function Dropdown({ items, itemCallback, hasFilter, styles }) {
  const [itemNow, setItem] = useState(items[0]);
  
  return (
    <div className="box-dropdown-filter-cover">
      <ButtonPrimary
        className="box-dropdown-filter"
        text={
          <>
            {hasFilter ? <BiFilterAlt style={{ fontSize: "1.3rem" }} /> : <></>}
            {itemNow}
            <MdArrowDropDown style={{ fontSize: "1.7rem" }} />
          </>
        }
      ></ButtonPrimary>
      <div className="box-dropdown-filter-selector" style={styles}>
        <ul>
          {items.map((item, key) => {
            return (
              <li
                key={key}
                onClick={() => {
                  setItem(item);
                  itemCallback(item);
                }}
              >
                <p className="txt-drop-down">{item}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
